import { clientPortalRequest, buildClientQuery } from "./clientPortalFetch";

const base = (clientViewId) => `/views/${clientViewId}/servicios`;

export function listVendorDirectoryCollectionSources(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/fuentes${buildClientQuery(params)}`);
}

export function getVendorDirectoryCollectionSource(clientViewId, sourceId) {
  return clientPortalRequest(`${base(clientViewId)}/fuentes/${sourceId}`);
}

export function updateVendorDirectoryCollectionSource(clientViewId, sourceId, body) {
  return clientPortalRequest(`${base(clientViewId)}/fuentes/${sourceId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function previewVendorDirectoryCollectionSourceDeletion(clientViewId, sourceId) {
  return clientPortalRequest(`${base(clientViewId)}/fuentes/${sourceId}/eliminacion`);
}

export function deleteVendorDirectoryCollectionSource(clientViewId, sourceId) {
  return clientPortalRequest(`${base(clientViewId)}/fuentes/${sourceId}`, {
    method: "DELETE",
  });
}

export function listVendorDirectoryConnectors(clientViewId) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/conectores`);
}

export function listVendorDirectoryCollectionPlans(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/planes${buildClientQuery(params)}`);
}

export function getVendorDirectoryCollectionPlan(clientViewId, planId) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/planes/${planId}`);
}

export function previewVendorDirectoryCollectionPlan(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/planes/preview`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateVendorDirectoryCollectionPlan(clientViewId, planId, body) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/planes/${planId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function createVendorDirectoryCollectionPlan(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/planes`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function activateVendorDirectoryCollectionPlan(clientViewId, planId) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/planes/${planId}/activar`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function pauseVendorDirectoryCollectionPlan(clientViewId, planId) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/planes/${planId}/pausar`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function listVendorDirectoryCollectionRunRecords(clientViewId, runId) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/ejecuciones/${runId}/registros`);
}

export function getVendorDirectoryCollectionSourceRecord(clientViewId, recordId) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/registros/${recordId}`);
}

export function listVendorDirectoryCollectionRuns(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/ejecuciones${buildClientQuery(params)}`);
}

export function getVendorDirectoryCollectionRun(clientViewId, runId) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/ejecuciones/${runId}`);
}

export function startVendorDirectoryCollectionRun(clientViewId, body) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/ejecuciones`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function retryVendorDirectoryCollectionRun(clientViewId, runId) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/ejecuciones/${runId}/reintentar`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function cancelVendorDirectoryCollectionRun(clientViewId, runId) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/ejecuciones/${runId}/cancelar`, {
    method: "POST",
    body: JSON.stringify({}),
  });
}

export function listVendorDirectorySourceRecords(clientViewId, params = {}) {
  return clientPortalRequest(`${base(clientViewId)}/colecciones/registros${buildClientQuery(params)}`);
}
